/**
 * Generated runtime TestId mirror for frontend/src/pages/AccessRequestDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

import {RequestStatus} from "../types/request-base.ts";

export const AccessRequestDetailTestIds = {
  accessRequestDetailPage: "access-request-detail-page",
  approveDialog: "approve-dialog",
  btnCancelRequest: "btn-cancel-request",
  cancelItemDialog: "cancel-item-dialog",
  cancelRequestDialog: "cancel-request-dialog",
  cardTitleJustification: "card-title-justification",
  cardTitleRequestDetails: "card-title-request-details",
  cardTitleRequestItems: "card-title-request-items",
  rejectDialog: "reject-dialog",
  statusBadge: (subtype: RequestStatus) => `status-badge-${subtype}` as const,
  statusBadgePrefix: () => "status-badge-" as TestIdPrefix,
  btnCancelItem: (item_id: string) => `btn-cancel-item-${item_id}`,
  btnCancelItemPrefix: () => "btn-cancel-item-" as TestIdPrefix,
  escalationTimeline: (step_id: string) => `escalation-timeline-${step_id}`,
  escalationTimelinePrefix: () => "escalation-timeline-" as TestIdPrefix,
  itemStatusBadge: (status: string) => `item-status-badge-${status}`,
  itemStatusBadgePrefix: () => "item-status-badge-" as TestIdPrefix,
  requestItem: (item_id: string) => `request-item-${item_id}`,
  requestItemPrefix: () => "request-item-" as TestIdPrefix
} as const;
